// extracted by mini-css-extract-plugin
export default {"sto-super-robot":"src_sto-super-robot__EVGSK"};